// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3r12p","toggleWrap":"styles_toggleWrap__18JWP","content":"styles_content__312Mj","selectAreaCode":"styles_selectAreaCode__4PRv9"};